export default "__VITE_ASSET__GL5IgsX2__"